import { useWindowSize } from '@vueuse/core'

import type { ShallowRef } from 'vue'

const TABLET_MIN_WIDTH = 740
const DESKTOP_MIN_WIDTH = 1280

interface ScreenWidthOptions {
  tabletMinWidth?: number
}

interface ScreenWidthReturn {
  isDesktop: ComputedRef<boolean>
  isTablet: ComputedRef<boolean>
  isMobile: ComputedRef<boolean>
  width: ShallowRef<number>
  height: ShallowRef<number>
}

export const useScreenWidth = ({ tabletMinWidth = TABLET_MIN_WIDTH }: ScreenWidthOptions = {}): ScreenWidthReturn => {
  const { width, height } = useWindowSize()

  const isDesktop = computed(() => width.value >= DESKTOP_MIN_WIDTH)
  const isTablet = computed(() => width.value >= tabletMinWidth && width.value < DESKTOP_MIN_WIDTH)
  const isMobile = computed(() => width.value < tabletMinWidth)

  return {
    isDesktop,
    isTablet,
    isMobile,
    width,
    height,
  }
}
